/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-array-index-key */
import { useState } from 'react';
import {
  Container,
  Typography,
  Button,
  Box,
  List,
  ListItem,
  ListItemText,
  Grid,
  Breadcrumbs,
  Link as MuiLink,
  Skeleton,
  IconButton,
  Modal,
  Tooltip,
  Alert,
  AlertTitle,
  Divider,
  AlertColor,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { Link as RouterLink, useParams, useLocation } from 'react-router-dom';
import LicensesTable from 'renderer/features/licenses-page/components/LicensesTable';
import { useAppSelector } from 'renderer/shared/state/hooks';
import { selectUser } from 'renderer/features/auth/state/userSelectors';
import { LoggedInUserState } from 'renderer/features/auth/state/userSlice';
import moment from 'moment';
import { PaymentMethod } from 'renderer/features/settings/schemas/paymentMethods.schemas';
import DeleteCardDialog from 'renderer/features/settings/components/DeleteCardDialog';
import AddCardDialog from 'renderer/features/settings/components/AddCardDialog';
import { useCloseNotificationMutation } from 'renderer/features/notifications/services/notifications.endpoints';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AuthorizeDialog from 'renderer/features/products-page/components/AuthorizeDialog';
import { useGetUserDetailsQuery } from '../services/users.endpoints';
import NotesComponent from './NotesComponent';
import UserDetailsTable from './Header';
import Subscriptions from './Subscriptions';
import PaymentMethods from './PaymentMethods';
import Payments from './Payments';
import EditUserDetailsDialog from './EditUserDetailsDialog';
import AddLicenseDialog from './AddLicenseDialog';

const Loader = () => {
  return <Skeleton />;
};

const UserDetails = () => {
  const [authDialogOpen, setAuthDialogOpen] = useState(false);
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';
  let { userId } = useParams();
  const user = useAppSelector(selectUser) as LoggedInUserState;
  if (!userId) {
    userId = user._id;
  }

  const isAdmin = user && user.role === 'admin';
  const {
    data: details,
    error,
    refetch,
  } = useGetUserDetailsQuery(userId ?? user?._id ?? '');
  console.log('getUserDetails error', error);
  const [closeNotification] = useCloseNotificationMutation();

  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState<
    'license' | 'subscription' | 'products'
  >('license');
  const [activeSerials, setActiveSerials] = useState<string[]>([]);
  const [showAddLicenseModal, setShowAddLicenseModal] = useState(false);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [paymentMethodFormOpen, setPaymentMethodFormOpen] = useState(false);
  const [mode, setMode] = useState<'create' | 'edit'>('create');
  const [selectedCard, setSelectedCard] = useState<PaymentMethod | undefined>();

  const [editUserDialogOpen, setEditUserDialogOpen] = useState(false);

  const handleOpenAddLicenseModal = () => {
    setShowAddLicenseModal(true);
    setModalType('license');
  };

  const handleOpenProductModal = (products: string[]) => {
    setActiveSerials(products); // reuse same array for display
    setModalType('products');
    setOpenModal(true);
  };

  const handleOpenModal = (serials: any) => {
    setActiveSerials(serials);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  if (!details) return <Loader />;

  const {
    licenses,
    transactions,
    subscriptions,
    paymentMethods,
    notifications,
    user: viewedUser,
  } = details;

  const { verificationToken, isEmailVerified } = viewedUser;
  const activated = verificationToken === '' && isEmailVerified;

  return (
    <>
      <Container maxWidth="lg" sx={{ pb: 20 }}>
        {isDashboard ? (
          <Breadcrumbs aria-label="breadcrumb" sx={{}}>
            <MuiLink underline="hover" color="inherit" href="/">
              Home
            </MuiLink>
            <Typography color="text.primary">Dashboard</Typography>
          </Breadcrumbs>
        ) : (
          <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
            <MuiLink underline="hover" color="inherit" href="/">
              Home
            </MuiLink>
            <MuiLink underline="hover" color="inherit" href="/#/users">
              Users
            </MuiLink>
            <Typography color="text.primary">User Details</Typography>
          </Breadcrumbs>
        )}
        <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mb: 4 }}>
          {isDashboard ? 'Dashboard' : 'User Details'}
        </Typography>

        <Box
          sx={{
            mt: -1,
            mb: 3,
            px: { xs: 1, sm: 2 },
            py: { xs: 1, sm: 1.5 },
            backgroundColor: '#e0f2f1',
            borderRadius: 1,
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.5,
            '&:hover': {
              backgroundColor: '#b2dfdb',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            },
            '&:active': {
              backgroundColor: '#a7d7d7',
            },
            fontSize: { xs: '0.85rem', sm: '1rem' },
            textAlign: 'left',
          }}
          onClick={() => setAuthDialogOpen(true)}
          role="button"
          tabIndex={0}
          aria-label="Open authorization instructions"
        >
          <InfoOutlinedIcon
            sx={{ fontSize: '1.3rem', color: '#00796b', flexShrink: 0 }}
          />
          <Typography sx={{ fontWeight: 500, fontSize: '0.95rem' }}>
            Need help authorizing a plugin or subscription? Click here for
            instructions.
          </Typography>
        </Box>

        <Grid container spacing={2}>
          {notifications &&
            notifications.map((notification) => (
              <Grid item xs={12}>
                <Alert
                  severity={notification.severity as AlertColor}
                  {...(!notification.showIcon && { icon: false })}
                  sx={{
                    // mb: 1,
                    border: `1px solid ${
                      notification.severity === 'info'
                        ? '#1976d2'
                        : notification.severity === 'warning'
                        ? '#ff9800'
                        : notification.severity === 'error'
                        ? '#d32f2f'
                        : '#2e7d32'
                    }`,
                    borderRadius: '5px',
                  }}
                  action={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{ mr: 2 }}
                      >
                        {moment(notification.createdAt).format(
                          'MMMM Do YYYY, h:mm:ss a',
                        )}
                      </Typography>
                      <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={() =>
                          closeNotification({
                            notificationId: notification._id,
                            userId: userId ?? '',
                          })
                        }
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  }
                >
                  <AlertTitle sx={{ fontWeight: 'bold' }}>
                    {notification.title}
                  </AlertTitle>
                  {notification.message}
                </Alert>
              </Grid>
            ))}

          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="h6" sx={{ p: 1, fontWeight: 'bold' }}>
                    User Details
                  </Typography>
                  {isAdmin && (
                    <>
                      <Tooltip title="Edit" placement="right">
                        <IconButton
                          // href="/#/settings"
                          onClick={() => setEditUserDialogOpen(true)}
                          size="small"
                          sx={{ borderRadius: 1, border: '1px solid #899094' }}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <EditUserDetailsDialog
                        open={editUserDialogOpen}
                        onClose={() => setEditUserDialogOpen(false)}
                        userId={userId}
                        activated={activated}
                      />
                    </>
                  )}
                </Box>
              </Box>
            </Box>
            <Divider sx={{ borderColor: '#000' }} />
            <UserDetailsTable userId={userId} />
          </Grid>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="h6" sx={{ p: 1, fontWeight: 'bold' }}>
                    Subscriptions
                  </Typography>
                  <IconButton
                    size="small"
                    sx={{ borderRadius: 1, border: '1px solid #899094' }}
                    onClick={handleOpenAddLicenseModal}
                  >
                    <AddIcon />
                  </IconButton>
                  {isAdmin && (
                    <Button
                      component={RouterLink}
                      variant="contained"
                      to={`/users/${userId}/create-subscription`}
                    >
                      Create Subscription
                    </Button>
                  )}
                </Box>
              </Box>
            </Box>
            <Divider sx={{ borderColor: '#000' }} />
            <Subscriptions
              subscriptions={subscriptions}
              userId={userId}
              refetchUserDetails={refetch}
              isAdmin={isAdmin}
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="h6" sx={{ p: 1, fontWeight: 'bold' }}>
                    Licenses
                  </Typography>
                  <IconButton
                    size="small"
                    sx={{ borderRadius: 1, border: '1px solid #899094' }}
                    onClick={handleOpenAddLicenseModal}
                  >
                    <AddIcon />
                  </IconButton>
                </Box>
              </Box>
            </Box>
            <Divider sx={{ borderColor: '#000' }} />
            <LicensesTable licenses={licenses} email={details.user.email} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ p: 1, fontWeight: 'bold' }}>
              Payments
            </Typography>
            <Divider sx={{ borderColor: '#000' }} />
            <Payments
              payments={transactions}
              handleOpenModal={handleOpenModal}
              handleOpenProductModal={handleOpenProductModal}
              isAdmin={isAdmin}
            />
          </Grid>

          {isAdmin && (
            <>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography
                        variant="h6"
                        sx={{ p: 1, fontWeight: 'bold' }}
                      >
                        Payment Methods
                      </Typography>
                      <IconButton
                        size="small"
                        sx={{ borderRadius: 1, border: '1px solid #899094' }}
                        onClick={() => {
                          setMode('create');
                          setPaymentMethodFormOpen(true);
                        }}
                      >
                        <AddIcon />
                      </IconButton>
                    </Box>
                  </Box>
                </Box>
                <Divider sx={{ borderColor: '#000' }} />
                <PaymentMethods
                  paymentMethods={paymentMethods}
                  onDeleteClick={(card) => {
                    setSelectedCard(card);
                    setDeleteDialogOpen(true);
                  }}
                  onEditClick={(card) => {
                    setSelectedCard(card);
                    setMode('edit');
                    setPaymentMethodFormOpen(true);
                  }}
                  userId={userId}
                />
              </Grid>
              <DeleteCardDialog
                open={deleteDialogOpen}
                onClose={() => setDeleteDialogOpen(false)}
                card={selectedCard}
              />
              <AddCardDialog
                open={paymentMethodFormOpen}
                onClose={() => setPaymentMethodFormOpen(false)}
                mode={mode}
                userId={userId}
                card={selectedCard}
              />
            </>
          )}
          <NotesComponent userId={userId} isAdmin={isAdmin} />
        </Grid>
      </Container>
      <AddLicenseDialog
        serialType={modalType as 'license' | 'subscription'}
        open={showAddLicenseModal}
        onClose={() => setShowAddLicenseModal(false)}
        email={details.user.email}
        // userId={userId}
        userId={details.user._id}
        refetchUserDetails={refetch}
        paymentMethods={paymentMethods}
      />
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="serials-modal-title"
        aria-describedby="serials-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography id="serials-modal-title" variant="h6" component="h2">
            Serial Numbers
          </Typography>
          <List dense id="serials-modal-description">
            {activeSerials.map((serial, index) => (
              <ListItem
                key={index}
                secondaryAction={
                  <Tooltip title="Copy to Clipboard" placement="top">
                    <IconButton
                      edge="end"
                      aria-label="copy"
                      onClick={() => copyToClipboard(serial)}
                    >
                      <ContentCopyIcon />
                    </IconButton>
                  </Tooltip>
                }
              >
                <ListItemText primary={serial} />
              </ListItem>
            ))}
          </List>
          <Button
            variant="outlined"
            onClick={handleCloseModal}
            style={{ marginTop: '20px' }}
          >
            Close
          </Button>
        </Box>
      </Modal>
      <AuthorizeDialog
        open={authDialogOpen}
        onClose={() => setAuthDialogOpen(false)}
      />
    </>
  );
};

export default UserDetails;
